import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
      redirectTo: 'home',
      pathMatch: 'full'
  },
  
  {
      path: 'home',
      loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
  },

  /*************************HABITACION **************************************/
  {
      path: 'habitacion',
      loadChildren: () => import('./habitacion/habitacion.module').then( m => m.HabitacionPageModule),
  },
  {
      path: 'zoom-habitacion',
      loadChildren: () => import('./zoom-habitacion/zoom-habitacion.module').then( m => m.ZoomHabitacionPageModule),
  },
  {
    path: 'music',
    loadChildren: () => import('./zoom-habitacion/music/music.module').then( m => m.MusicPageModule)
  },
  {
    path: 'tv',
    loadChildren: () => import('./zoom-habitacion/tv/tv.module').then( m => m.TvPageModule)
  },
  {
    path: 'recepcion',
    loadChildren: () => import('./zoom-habitacion/recepcion/recepcion.module').then( m => m.RecepcionPageModule)
  },
  /****************************************  BANNER NOTICIAS   ************************************************ */
  {
    path: 'topdestinos',
    loadChildren: () => import('./zoom-habitacion/topdestinos/topdestinos.module').then( m => m.TopdestinosPageModule)
  },
  {
    path: 'tepuedeinteresar',
    loadChildren: () => import('./zoom-habitacion/tepuedeinteresar/tepuedeinteresar.module').then( m => m.TepuedeinteresarPageModule)
  },
  {
    path: 'ultimahora',
    loadChildren: () => import('./zoom-habitacion/ultimahora/ultimahora.module').then( m => m.UltimahoraPageModule)
  },
  {
    path: 'actividades',
    loadChildren: () => import('./zoom-habitacion/actividades/actividades.module').then( m => m.ActividadesPageModule)
  },

	/****************************************  DOMO   ************************************************ */
	{
		path: 'resume-stay',
		loadChildren: () => import('./zoom-habitacion/resume-stay/resume-stay.module').then( m => m.ResumeStayPageModule)
	},

	/****************************************  TIEMPO   ************************************************ */
  {
      path: 'weather',
      loadChildren: () => import('./weather/weather.module').then( m => m.WeatherPageModule)
  },

  /****************************************  TIEMPO   ************************************************ */
  {
      path: 'mantenimiento',
      loadChildren: () => import('./mantenimiento/mantenimiento.module').then( m => m.MantenimientoPageModule)
  },

  /****************************************  RESERVAS   ************************************************ */
  {
    path: 'reservas',
    loadChildren: () => import('./reservas/reservas.module').then( m => m.ReservasPageModule)
  },

  /****************************************  MARKETING   ************************************************ */
  {
      path: 'mantenimiento',
      loadChildren: () => import('./marketing/marketing.module').then( m => m.MarketingPageModule)
  },

  /****************************************  EFICIENCIA   ************************************************ */
	{
		path: 'resume-stay',
		loadChildren: () => import('./eficiencia/eficiencia.module').then( m => m.EficienciaPageModule)
	},

  {
		path: 'consumos',
		loadChildren: () => import('./consumos/consumos.module').then( m => m.ConsumosPageModule)
	},


  /****************************************  CUADRO ELECTRICO   ************************************************ */
	{
		path: 'cuadroelectrico',
		loadChildren: () => import('./mantenimiento/cuadro_electrico/cuadro_electrico.module').then( m => m.CuadroElectricoPageModule)
	},
  {
    path: 'zoom_cuadro_electrico',
    loadChildren: () => import('./mantenimiento/cuadro_electrico/zoom/zoom.module').then( m => m.ZoomPageModule)
 },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
